const filter = {
	filterNumber(val){
		let regular = /^[0-9]*$/;
		if(!regular.test(val)){
			return true
		}
	},
	completionCode(val){
		console.log(val.length)
		if(val.length == 1){
			return 10000000000+val
		}
		switch (val.length){
			case 1:
				return 10000000000+val
			case 2:
				return 1000000000+val
			case 3:
				return 100000000+val
			case 4:
				return 10000000+val
			case 5:
				return 1000000+val
			case 6:
				return 100000+val
			case 7:
				return 10000+val
			case 8:
				return 1000+val
			case 9:
				return 100+val
			case 10:
				return 10+val
			case 11:
				return 1+val
			case 12:
				return val
		}
	}
}





export default filter
